import styled from 'styled-components'

export const RemotePopupBodyContentUi = styled.div`
  min-height: 100px;
  max-height: inherit;
`
